import { Loader2 } from "lucide-react";
import { motion } from "framer-motion";
import { animations } from "../lib/animations";

type Props = {
  icon?: React.ReactNode;
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  loading?: boolean;
  accessory?: React.ReactNode;
  center?: boolean;
};

export default function SecondaryButton({
  icon,
  title,
  subtitle,
  onClick,
  disabled,
  loading,
  accessory,
  center = false,
}: Props) {
  return (
    <motion.button
      whileTap={!disabled && !loading ? animations.button.tap : undefined}
      whileHover={!disabled && !loading ? animations.button.hover : undefined}
      transition={animations.spring.medium}
      style={{
        background: "var(--button-secondary-background)",
        borderColor: "var(--button-secondary-border-color)",
        borderWidth: "var(--button-secondary-border-width)",
        borderRadius: "var(--button-secondary-border-radius)",
        padding: "var(--button-secondary-padding)",
      }}
      className="mt-1 min-h-11 flex items-center justify-between w-full group disabled:cursor-not-allowed disabled:opacity-50 hover:opacity-80 transition-opacity"
      onClick={onClick}
      disabled={disabled || loading}
    >
      <div
        className={`flex gap-2 items-center text-sm flex-1 min-w-0 ${center ? "justify-center" : "justify-start"}`}
      >
        <div className="flex-shrink-0">{icon}</div>
        <div
          className={`flex-1 min-w-0 ${center ? "text-center" : "text-start"}`}
        >
          <div className="text-[--color-text-primary] truncate">{title}</div>
          {subtitle ? (
            <div className="mt-0.5 text-[--color-text-secondary] text-xs truncate">
              {subtitle}
            </div>
          ) : null}
        </div>
      </div>
      <div className="flex-shrink-0 ml-2">
        {accessory ? (
          <div className={loading ? "opacity-50 animate-pulse" : ""}>
            {accessory}
          </div>
        ) : loading ? (
          <Loader2 className="animate-spin w-5 h-5 text-[--color-text-secondary]" />
        ) : null}
      </div>
    </motion.button>
  );
}
